import { Navigate, Outlet } from "react-router-dom";

import { getFallbackRoute } from "@/config/routes";
import { useHasAiFeature } from "@/hooks/use-ai-enabled";
import { AiFeature } from "@/types/workspace";

type AiFeatureRouteProps = {
  feature: AiFeature;
};

/**
 * Route guard that only renders its children when admin picked `feature` for
 * the active workspace. Deliberately ignores the workspace's AI switch, so a
 * workspace can set things up before turning AI on. Otherwise it redirects to
 * the user's normal fallback route.
 */
export const AiFeatureRoute = ({ feature }: AiFeatureRouteProps) => {
  const enabled = useHasAiFeature(feature);

  if (!enabled) return <Navigate replace to={getFallbackRoute()} />;

  return <Outlet />;
};
